module.exports = __webpack_public_path__ + "static/img/trt_sy_icon.png";